import {
  GET_RANGE_SKIN_BODY_CARE,
  GET_RANGE_HAIR_CARE,
  GET_RANGE_HAIR_COLOR,
  GET_RANGE_MAKE_UP,
  GET_RANGE_MENS,
  GET_RANGE_PERM,
  GET_RANGE_STYLING,
} from '../constants';
import { getContent } from '../../services/api';

const fetchProductRange = (slug, locale, range) => ({
  type: (() => {
    switch (range) {
      case 'skin-body-care':
      case 'productRangeSkinBodyCare':
        return GET_RANGE_SKIN_BODY_CARE;
      case 'hair-care':
      case 'productRangeHairCare':
        return GET_RANGE_HAIR_CARE;
      case 'hair-color':
      case 'productRangeHairColor':
        return GET_RANGE_HAIR_COLOR;
      case 'make-up':
      case 'productRangeMakeUp':
        return GET_RANGE_MAKE_UP;
      case 'mens':
      case 'productRangeMens':
        return GET_RANGE_MENS;
      case 'perm':
      case 'productRangePerm':
        return GET_RANGE_PERM;
      case 'styling':
      case 'productRangeStyling':
        return GET_RANGE_STYLING;
      default:
        return null;
    }
  })(),
  payload: getContent({
    contentType:
      {
        'skin-body-care': 'productRangeSkinBodyCare',
        'hair-care': 'productRangeHairCare',
        'hair-color': 'productRangeHairColor',
        'make-up': 'productRangeMakeUp',
        mens: 'productRangeMens',
        perm: 'productRangePerm',
        styling: 'productRangeStyling',
      }[range] || range,
    slug,
    locale,
  }),
});

export default fetchProductRange;



// WEBPACK FOOTER //
// ./src/redux/actions/productRange.js